import {FormControl, Grid, InputLabel, MenuItem, Select, Typography} from "@mui/material";
import React, {useMemo} from "react";
import {selectChange, SetState} from "../../util/FormHandlers";


export function StringEnumFilter<EnumType extends string | number, Filter extends { [p in PropertyName]: EnumType }, PropertyName extends keyof Filter>(
    {
        label,
        filter,
        setFilter,
        property,
        headerOption,
        options,
    }: {
        label: string,
        filter: Filter,
        setFilter: SetState<Filter>,
        property: PropertyName,
        headerOption?: string,
        options: {
            value: EnumType,
            label: string,
        }[],
    }
) {

    const labelId = useMemo(
        () => label.toLowerCase().replaceAll(' ', '-') + '-label',
        [label],
    );

    const handleChange = useMemo(
        () => selectChange(
            setFilter,
            (newValue: EnumType | string) => ({[property]: newValue as EnumType} as Partial<Filter>),
        ),
        [setFilter, property],
    )


    return (
        <Grid size={{lg: 2, md: 3, xs: 12}}>
            <FormControl fullWidth variant="outlined">
                <InputLabel id={labelId}>{label}</InputLabel>
                <Select
                    labelId={labelId}
                    value={filter[property]}
                    onChange={handleChange}
                    label={label}
                >
                    {headerOption && (
                        <Typography variant="caption" color="textPrimary" p={2}>
                            {headerOption}
                        </Typography>
                    )}
                    {options.map(option => (
                        <MenuItem key={option.value || 'empty'} value={option.value}>{option.label}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Grid>
    );
}
